import { Container, SectionHead, Btn, CheckList } from "./Ui";
import { Reveal } from "./Motion";
import { PageHero, CtaBand } from "./Blocks";
import { EnquiryForm } from "./EnquiryForm";

export const ModelCards = ({ models }) => (
  <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
    {models.map((m, i) => (
      <Reveal key={m.code} delay={i * 0.06} className="card-soft group relative overflow-hidden p-7">
        <span className="font-display text-5xl font-extrabold tracking-tight text-[#102B50] transition-colors duration-300 group-hover:text-[#2878E5]">{m.code}</span>
        <h3 className="mt-4 font-display text-lg font-bold text-[#102B50]">{m.name}</h3>
        <p className="mt-2 text-[15px] leading-relaxed text-[#4A5D78]">{m.text}</p>
      </Reveal>
    ))}
  </div>
);

export const FeatureGrid = ({ items }) => (
  <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
    {items.map((f, i) => (
      <Reveal key={f.title} delay={(i % 3) * 0.06} className="card-soft group p-7">
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#E8F1FD] text-[#2878E5] transition-transform duration-300 group-hover:-rotate-6"><f.icon className="h-5 w-5" /></span>
        <h3 className="mt-6 font-display text-lg font-bold text-[#102B50]">{f.title}</h3>
        <p className="mt-2 text-[15px] leading-relaxed text-[#4A5D78]">{f.text}</p>
      </Reveal>
    ))}
  </div>
);

export const Steps = ({ steps }) => (
  <ol className="mt-14 grid gap-px overflow-hidden rounded-[24px] border border-white/10 bg-white/10 md:grid-cols-2 lg:grid-cols-4">
    {steps.map(([t, d], i) => (
      <Reveal as="li" key={t} delay={i * 0.08} className="bg-[#102B50] p-8">
        <span className="font-display text-sm font-bold text-[#8EC0FF]">Step 0{i + 1}</span>
        <h3 className="mt-4 font-display text-xl font-bold text-white">{t}</h3>
        <p className="mt-2 text-[15px] leading-relaxed text-slate-300">{d}</p>
      </Reveal>
    ))}
  </ol>
);

export const PartnerLanding = ({ cfg }) => (
  <>
    <PageHero eyebrow={cfg.eyebrow} lines={cfg.lines} text={cfg.intro} testid={`${cfg.key}-hero`}>
      <Btn href="#enquiry" data-testid={`${cfg.key}-hero-cta`}>{cfg.cta}</Btn>
      <Btn to="/solutions" variant="outline" arrow={false}>View Solutions</Btn>
    </PageHero>

    <section className="bg-[#F4F7FB] py-20 lg:py-28" data-testid={`${cfg.key}-features`}>
      <Container>
        <SectionHead eyebrow={cfg.featuresEyebrow} title={cfg.featuresTitle} text={cfg.featuresText} />
        <FeatureGrid items={cfg.features} />
      </Container>
    </section>

    <section className="bg-white py-20 lg:py-28" data-testid={`${cfg.key}-models`}>
      <Container>
        <SectionHead eyebrow="Marketing models" title={cfg.modelsTitle} text={cfg.modelsText} />
        <ModelCards models={cfg.models} />
      </Container>
    </section>

    <section className="bg-[#102B50] py-20 lg:py-28" data-testid={`${cfg.key}-process`}>
      <Container>
        <SectionHead light eyebrow={cfg.stepsEyebrow} title={cfg.stepsTitle} />
        <Steps steps={cfg.steps} />
      </Container>
    </section>

    <section id="enquiry" className="scroll-mt-24 bg-white py-20 lg:py-28" data-testid={`${cfg.key}-enquiry`}>
      <Container className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionHead eyebrow={cfg.formEyebrow} title={cfg.formTitle} text={cfg.formText} />
          <Reveal delay={0.1} className="mt-8"><CheckList items={cfg.formPoints} /></Reveal>
        </div>
        <Reveal delay={0.1} className="card-soft !translate-y-0 p-6 sm:p-10 lg:col-span-7">
          <EnquiryForm source={cfg.key} defaultType={cfg.defaultType} submitLabel={cfg.cta} />
        </Reveal>
      </Container>
    </section>
    <CtaBand primary={[cfg.cta, "#enquiry"]} />
  </>
);
